import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { isTruthy } from '@nestech/utils';
import { Observable, of } from 'rxjs';
import { Authentication } from '../auth';
import { isApiUrl } from './api-url';

@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {
  #authApi = inject(Authentication);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!isApiUrl(req.url)) {
      return next.handle(req);
    }
    const isPatch = req.method === 'PATCH';

    if ([isPatch].some(isTruthy) && this.#authApi.isRestricted()) {
      return of(new HttpResponse({ body: {}, status: 200 }));
    }

    const authReq = req.clone({
      setHeaders: { ...this.#authApi.authHeaders() },
      // A cookie session may be issued by a host the app is not served from; same-origin this is a no-op.
      withCredentials: true,
    });
    return next.handle(authReq);
  }
}
